module.exports = __webpack_public_path__ + "img/header-weddingRingsSecretHeart.4279655.webp";